import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { ProductGroupModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@BO({ modelType: ProductGroupModel })
export class ProductGroupBO extends BusinessObjectBase<ProductGroupModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.configureValidationRules();
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation) && sameValues(conflict.objectProperties!, ['name'])) {
            this.addExternalRuleViolations({
                [this.model.sun]: [{
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.product-group.validation.name.server-rule-violations.non-unique-model-data-error'),
                }]
            });
        }
    }

    private configureValidationRules(): void { }
}
